// Pure helpers for the contact form. Kept separate so ContactPage stays
// presentational and these helpers are independently testable.

import axios from "axios";
import { API } from "../../data/constants";

export const CREDIT_PREFILL_MESSAGE =
  "I'd like to claim the $500 starter credit and launch my first SmartReach\u2122 Ads Manager campaign. Please help me get set up.";

export const EMPTY_FORM = {
  name: "",
  email: "",
  phone: "",
  business_name: "",
  message: ""
};

/**
 * Build the initial form state given a known lead source. Currently only the
 * credit-claim source pre-fills the message; everything else starts blank.
 */
export const buildInitialFormData = (source) => ({
  ...EMPTY_FORM,
  message: source === "credit-claim" ? CREDIT_PREFILL_MESSAGE : ""
});

/**
 * Submit the contact form to the backend. Returns a discriminated result
 * object so the component never has to handle thrown errors directly.
 */
export const submitContactForm = async ({ formData, isUAE, source }) => {
  try {
    const response = await axios.post(`${API}/contact`, {
      ...formData,
      region: isUAE ? "UAE" : "US",
      source: source || undefined
    });
    return { type: "success", message: response.data.message };
  } catch (error) {
    return {
      type: "error",
      message: error.response?.data?.detail || "Something went wrong. Please try again."
    };
  }
};
